export interface TaskDashboardResponse {
    tasksCompleted: number;
    tasksOutstanding: number;
}

export function createTaskDashboardResponse(): TaskDashboardResponse {
    return {
        tasksCompleted: 0,
        tasksOutstanding: 0,
    };
}
